export enum EFilterConfigType {
  date = 'date',
  number = 'amount',
  list = 'list',
  string = 'string',
  time = 'time',
}

export interface IFilterConfig {
  key: string;
  label: string;
  type: EFilterConfigType;
  data:
    | IFilterConfigNumber
    | IFilterConfigDate
    | IFilterConfigList
    | IFilterConfigString;
  selected: boolean;
}

export interface IFilterConfigDate {
  values: string[];
}

export interface IFilterConfigNumber {
  keys?: string[] | string;
  values: string[];
}

export interface IFilterConfigString {
  values: string[];
  placeholder: string;
}

export interface IFilterConfigListOption {
  name: string;
  value: string | string[];
}

export interface IFilterConfigList {
  keys?: string | string[];
  options: IFilterConfigListOption[];
  values: string[];
}
